import React, { ReactNode, useMemo } from 'react';
import { CancelledError, ReactQueryConfig, ReactQueryConfigProvider } from 'react-query';
import { useDispatch } from 'react-redux';

import { showNetworkError } from '../notification/actions';

interface QueryConfigProviderProps {
    children: ReactNode;
}

export const QueryConfigProvider = ({ children }: QueryConfigProviderProps) => {
    const dispatch = useDispatch();

    const config: ReactQueryConfig = useMemo(
        () => ({
            queries: {
                retry: 0,
                refetchOnWindowFocus: false,
                onError: (error) => {
                    if (error instanceof CancelledError) {
                        // запрос отменен, ошибку не показываем, удалить после обновления на v3
                        // https://github.com/tannerlinsley/react-query/discussions/1179
                        return;
                    }
                    console.error(error);
                    dispatch(showNetworkError(error));
                },
            },
            mutations: {
                onError: (error) => {
                    console.error(error);
                    dispatch(showNetworkError(error));
                },
            },
        }),
        [dispatch]
    );
    /* @ts-ignore - EDUCATION-37077: [react-update]: fixme typings: обновить до совместимого по тайпингам с react18 */
    return <ReactQueryConfigProvider config={config}>{children}</ReactQueryConfigProvider>;
};
